import React from 'react';
import { Typography } from '@material-ui/core';

import StefanZechmannHero from '../../../../../../../images/test-assignment-zechmann-hero-fr.png';

const FR = () => (
  <>
    <img
      src={StefanZechmannHero}
      alt="Order your assigned test"
      className="sidebar__image"
    />
    <div className="sidebar__main-content">
      <Typography variant="body2">
        <br />
        <br />
        Un test de laboratoire à domicile t’a été attribué par le Dr Stefan
        Zechmann.
        <br />
        <br />
        Merci de suivre les étapes suivantes :
        <br />
        <br />
        <b>1. Commander le test</b>
        <br />
        Clique sur le bouton &quot;Commander&quot; à la fin de cet e-mail et
        suis les instructions pour finaliser ta commande
        <br />
        <br />
        <b>À noter :</b> Il s&apos;agit d&apos;une prestation à la charge du
        patient. Aucun remboursement par l’assurance de base n’est possible.
        <br />
        <br />
        <b>2. Réaliser ton test confortablement chez toi</b>
        <br />
        2 à 3 jours ouvrables après la commande, tu recevras ton kit de test
        dans une enveloppe discrète, envoyée par la poste. Le kit contient un
        code d’activation, tout le matériel nécessaire, ainsi que des
        instructions faciles à comprendre pour prélever ton échantillon.
        Ensuite, il te suffit d’emballer l’échantillon dans la boîte de retour
        fournie et de la déposer dans n’importe quelle boîte aux lettres de La
        Poste Suisse.
        <br />
        <br />
        <b>3. Recevoir les résultats</b>
        <br />
        Ton échantillon sera analysé par Medisyn, un prestataire de services de
        laboratoire leader en Suisse. Dès que tes résultats seront disponibles,
        tu recevras un e-mail contenant un lien pour réserver ta consultation de
        suivi avec le Dr Stefan Zechmann. Après cette consultation, les
        résultats seront mis à ta disposition en ligne.
      </Typography>
      <button type="button" className="sidebar__button">
        Commande test attribué
      </button>
      <Typography variant="body2">
        Si tu as des questions, tu peux nous contacter à tout moment à
        l&apos;adresse suivante : service@yourself.health
      </Typography>
    </div>
    <div className="sidebar__footer">
      <Typography variant="body2">
        Health Yourself
        <br />
        <br />
        Lerchenfeldstrasse 3, 9014 St. Gallen, Switzerland
        <br />
        <br />
        Tu ne veux plus recevoir ces e-mails ? Désabonne-toi
        <br />
        <br />© 2025 Health Yourself
      </Typography>
    </div>
  </>
);

export default FR;
